import type { AppApi } from '@wix/wix-data-client-common'

export interface PageLinkGenerationPayload {
  collectionId: string
  fields: string[]
}

export const onPageLinkGeneration = (
  appApi: AppApi,
  { collectionId, fields }: PageLinkGenerationPayload,
): void => {
  appApi.refreshRoutersAndEmitPageLinkGenerationEvent({
    collectionId,
    pageLinkKeys: fields,
  })
}
